module.exports = (__parcel__import__("8ftEn")).then(() => parcelRequire('jppWD'));